import { FunctionComponent } from 'react';
import { Routes, Route } from 'react-router-dom';
import InitialMAP from 'src/pages/authentication/InitialMAP';
import ActionItems from 'src/pages/dashboard/NEATT/ActionItems';
import ClaimMAP from 'src/pages/dashboard/NEATT/ActionableItems/ClaimMAP';
import PayAndBook from 'src/pages/dashboard/NEATT/ActionableItems/PayAndBook';
import PurchaseMAP from 'src/pages/dashboard/NEATT/ActionableItems/PurchaseMAP';
import ProfileNotes from 'src/pages/dashboard/NEATT/ProfileNotes';

const NEATTRoutes: FunctionComponent = () => (
    <Routes>
        <Route path='/profile-notes' element={<ProfileNotes />} />
        <Route path='/action-items' element={<ActionItems />} />
        <Route path='/appointment-payment' element={<PayAndBook />} />
        <Route path='/purchase-map' element={<PurchaseMAP />} />
        <Route path='/claim-map' element={<ClaimMAP />} />
        <Route path='/recall-map' element={<InitialMAP recall={true} />} />
    </Routes>
);

export default NEATTRoutes;